/*
* container.js
*
* Container object class and associated functions for handling container objects
*/


var GetDecimalFromPresentage = function(str){
    return parseFloat(str.substring(0, str.length - 1)) / 100;
};

function dragEndListener (event) {

    var target = event.target;
    var id = $(target).attr('id');

    if( g_container_list[id] === undefined ){
      return;
    }

    var totalWidth = GetCurrentDeckLength();
    var totalHeight = GetDeckAreaHeight();
    var left = GetXPostitionInPresentage($(target).position().left);
    var top = GetYPostitionInPresentage($(target).position().top);

    var x = totalWidth * GetDecimalFromPresentage(left);
    var y = totalHeight * GetDecimalFromPresentage(top);


    g_container_list[id].position.x = x;
    g_container_list[id].position.y = y;

    g_container_is_dirty = true;

    $(target).css({left : left});
    $(target).css({top :top});

    target.style.webkitTransform =
        target.style.transform =
            'translate(' + 0 + 'px, ' + 0 + 'px)';

    // update the posiion attributes
    target.setAttribute('data-x', 0);
    target.setAttribute('data-y', 0);
    VRC.ContainerService.clearConflictedStatus(id);
    UpdateAllDeckTotals();
    g_isDragging = false;
};


function dragMoveListener (event) {
    event.preventDefault();
    event.stopPropagation();

  var target = event.target,
  // keep the dragged position in the data-x/data-y attributes
      x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
      y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

  // translate the element
  target.style.webkitTransform =
      target.style.transform =
          'translate(' + x + 'px, ' + y + 'px)';

  // update the posiion attributes
  target.setAttribute('data-x', x);
  target.setAttribute('data-y', y);
};

function shouldDGIconsBePrinted(containerDiv, iconSize, iconCount) {
    return Math.max( containerDiv.outerWidth(), containerDiv.outerHeight()- containerDiv.find('.container_name').outerHeight() )  > iconSize * iconCount;
}

function getDGFormattedList(string, containerDiv, tagArea) {

    var iconSize = 16,
    formattedList = '',
    stringArray;

    tagArea.find('.dangerous').remove();

    stringArray = string.split(',');

    if (string !== '' && stringArray.length > 0 && shouldDGIconsBePrinted(containerDiv, iconSize, stringArray.length)) {
        stringArray.forEach(function (item) {
            item = item.replace('.','-').replace(' ','');
            formattedList += '<span class="container_tag dg_icons dangerous transparent"><img src="images/dg_icons/DG_Class_' + item + '_48.png" width="' + iconSize +'" height"' + iconSize + '" /></span>';
        });
    } else {
        formattedList = '<div class="container_tag dangerous">D</div>';
    }

    tagArea.prepend(formattedList);
}

function validateDgClasses(dgClass) {
    return dgClass.replace(/[,\s]+/g, ',').replace(/^[,]+|[,]+$/g, '');   // replace 1+ comma with ',' , remove 1+ comma at the beginning and the end of the string.
}

/* Functions for setting those parameters that will need a visual update
*/
container.prototype.ChangePosition = function (x, y) {

  this.position.x = x;
  this.position.y = y;
  this.UpdateContainerVisual();
};

container.prototype.ChangeRotation = function ( rotation ) {
  this.features.rotation = rotation;
  this.UpdateContainerVisual();
};

container.prototype.hasWeight = function ( rotation ) {

    return isNaN(parseInt(this.features.weight)) ? 0 : parseInt(this.features.weight) > 0;
};

container.prototype.getId = function (  ) {
  return this.id;
};

container.prototype.getDgClass = function ( ) {
  return this.dg_class;
};

container.prototype.hasDgClass = function (  ) {
  return this.dg_class !== "" && this.dg_class !== undefined;
};


container.prototype.ChangeSize = function ( length, width ) {
  this.features.length = length;
  this.features.width = width;
  this.UpdateContainerVisual();
}

container.prototype.ChangeColor = function ( colour ) {
  this.colour = colour;
  this.UpdateContainerVisual();
}

container.prototype.SetProperty = function ( property, show ) {
  if( this.properties[property] === undefined )
    return;

  this.properties[property] = show;
  this.UpdateContainerVisual();
}


var ShowContainerInfo = function (event) {
  var $containerDom = $(event.target).closest(".deckstate_container");

  HoverInfoBox($containerDom, true);
  event.preventDefault();
};

var EditContainer = function (event) {

  if($(event.target).closest(".popover").length > 0){
    return;
  }


  event.preventDefault();
  var $containerDom = $(event.target).closest(".deckstate_container");
  HoverInfoBox($containerDom, false);

  var containerId = $containerDom.attr('id');
  VRC.ContainerEditModal.show(containerId);

};

var selectContainer = function ($containerEl) {
    unselectContainer();
    $containerEl.addClass('highlighted');
    var id = $containerEl.attr('id');
    g_selected_container = g_container_list[id];
};

var unselectContainer = function(){
    if(g_selected_container){
        var $containerEl = $(g_selected_container.divID);
        $containerEl.removeClass('highlighted');
        g_selected_container = null;
    }
};


/* Initialises container */

container.prototype.InitialiseVisual = function ( p_containingID )  {
  var duplicate = false;
  if( $(this.divID).length > 0 ) {
    duplicate = true;
   $(this.divID).remove();  // remove container first if visual representation already exists
  }

  this.divID = '#' + this.id;

  var width =  CalculatePresentageOfDeckLength(this.features.length);
  var height = CalculatePresentageOfDeckWidth(this.features.width);
  var x =  CalculatePresentageOfDeckLength(this.position.x);
  var y = CalculatePresentageOfDeckWidth(this.position.y);

  var ctx = {
    id : this.id,
    color : this.colour,
    y : y,
    x : x,
    tag : this.tag
  };

 var html = WELL.Handlebars.VRC.container(ctx);
  $(p_containingID).append(html);




 if(!duplicate){
     interact(this.divID).draggable({
     restrict: {
      restriction: "#deck",
      endOnly: false,
      elementRect: { top: 0, left :0  , bottom: 1, right: 1 }
    },
    onstart : function(event){
      VRC.ContainerPopoverView.hide();
      g_isDragging = true;
      var $containerEl = $(event.target);
      var id = $containerEl.attr('id');
      VRC.ContainerService.drawConflictedStatus(id);
      HighlightContainers('clear');
      $('#popup_dialog').dialog('close' );
      var $containerEl = $(event.target);
      if($containerEl.hasClass('deckstate_container')){
        selectContainer($containerEl);
      }
    },
    // call this function on every dragmove event
    onmove: dragMoveListener,
    // call this function on every dragend event
    onend : dragEndListener
  });

 interact(this.divID)
     .on('tap', function (event) {
         event.stopPropagation();
          var $containerEl = $(event.target).closest('.deckstate_container');
          if($containerEl.hasClass('deckstate_container')){
              selectContainer($containerEl);
          }
         ShowContainerInfo(event);
     })
     .on('dblclick doubletap', function (event) {
         EditContainer(event);
     })
 }
  this.UpdateContainerVisual();
};

/* Updates visual content of container */
container.prototype.UpdateContainerVisual = function () {

  if( this.divID === undefined )
    return;

  var $l_div = $( this.divID );

  if(this.deckId !== 'outgoing_area'){
      $l_div.css( 'background-color', this.colour );
  }


  var $l_tag_area = $( $l_div.children('.container_tag_area') );
  if( $l_tag_area === undefined )
    VRC.ErrorHandleService.showMessage("tag_area not found. Can't update visual tags for container: " + this.divID, G_MSG_TYPE_ERROR );

  if( this.features.rotation == 0 ) {
    $l_div.css( 'width', CalculatePresentageOfDeckLength(this.features.length) );
    $l_div.css( 'height', CalculatePresentageOfDeckWidth(this.features.width));
  }
  else {
    $l_div.css( 'width', CalculatePresentageOfDeckLength(this.features.width) );
    $l_div.css( 'height', CalculatePresentageOfDeckWidth(this.features.length));
  }

  var left = CalculatePresentageOfDeckLength(this.position.x);
  var top = CalculatePresentageOfDeckWidth(this.position.y);


  $l_div.css('left', left );
  $l_div.css('top',top);

  $l_div.html('<span class="container_name"> '+ this.tag +'</span>');

  // add for tags or backgrounds
  var $l_tag = $( $l_tag_area.children('.container_tag.roundtrip') );
    this.properties.roundtrip ? $l_tag.css('display', 'block' ) : $l_tag.css('display', 'none');

  $l_tag = $( $l_tag_area.children('.container_tag.backload') );
  this.properties.backload ?  $l_tag.css('display', 'block' ) : $l_tag.css('display', 'none');

  $l_tag = $( $l_tag_area.children('.container_tag.dangerous') );
  if (this.properties.dangerous)  {
    getDGFormattedList(this.dg_class, $l_div, $l_tag_area);
  }
  else {
    $l_tag.css('display', 'none');
  }

  $l_tag = $( $l_tag_area.children('.container_tag.storage') );
  this.properties.storage ? $l_tag.css('display', 'block') : $l_tag.css('display', 'none');

  $l_tag = $( $l_tag_area.children('.container_tag.priority') );
  this.properties.priority ? $l_tag.css('display', 'block') : $l_tag.css('display', 'none');

  $l_tag = $($l_tag_area.children('.container_tag.transfer') );
  this.properties.transfer ? $l_tag.css('display', 'block') : $l_tag.css('display', 'none');

  $l_tag = $($l_tag_area.children('.container_tag.heavy-lift') );
  this.properties.heavy_lift ? $l_tag.css('display', 'block') : $l_tag.css('display', 'none');

  $l_tag = $($l_tag_area.children('.container_tag.refrigerated') );
  this.type === G_CONTAINER_TYPES.REFRIGERATED ? $l_tag.css('display', 'block') : $l_tag.css('display', 'none');

  $l_div.append( $l_tag_area ); // disappear when rotating, so need to re-add

  g_container_is_dirty = true;

  UpdateColorMap();
 };

container.prototype.DeleteContainerVisual = function () {
  if( this.divID === undefined )
    return;

  $(this.divID).remove();
  this.divID = undefined;
};

container.prototype.isOnDeck = function () {
   return ["outgoing_area", "transit_area"].indexOf(this.deckID) === -1;
};

function container( p_obj, p_opts ) {

  if( p_opts['new'] == true ) {
    var l_date = new Date();
    this.id = 'container_' + Math.floor( Math.random()* 1000 ) + '_' + l_date.getTime();
    this.divID = undefined;
  }
  else {
    this.id = p_obj.id;
    this.divID = p_obj.divID; // not needed?
  }
  this.prev_id = p_obj.prev_id;
  this.tag = p_obj.tag;
  this.type = p_obj.type;
  this.remarks = p_obj.remarks;

  this.deckID = p_obj.deckID;

  if( this.deckID === undefined ) {
    this.deckID = 'transit_area';
  }

  if(p_obj.dg_class !== undefined) {
    this.dg_class = VRC.Utils.String.validateDgClasses(p_obj.dg_class);
  }
  if(p_obj.dg_info !== undefined) {
    this.dg_info = p_obj.dg_info;
  }

  if(p_obj.cargo_dg_info !== undefined) {
    this.cargo_dg_info = p_obj.cargo_dg_info;
  }

  this.destination = p_obj.destination;
  this.origin = p_obj.origin;

  this.colour = p_obj.colour;
  if( this.colour === undefined || this.colour == null) {
    this.colour = G_CONTAINER_COLOURS['DECK'];
  }

  this.image = p_obj.image;

  this.features = p_obj.features;
  this.position = p_obj.position;


  this.properties = p_obj.properties;

  // Converting to bools for consistency
  for( var l_key in this.properties ) {
    this.properties[l_key] = Boolean( this.properties[l_key]);
  }

  // Dummy check to make sure length and width have been set
  if( this.features.length === undefined || this.features.length <= 0 ) {
    this.features.length = 1;
  }
  if( this.features.width === undefined || this.features.width <= 0 ) {
    this.features.width = 1;
  }


}
